export class OriginModel {
  City?: null;
  CountryCode?: null;
  IpAddress: string;
  IsImported: boolean;
  Region?: null;
  Timezone?: null;
  UserAgent: string;
}
